import { GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { setArPreviewStatus } from '../_redux-ui';

export const registerArErrorHandler = (store: GiftPdpStore) => {
    if (process.env.REACT_APP_TO_BUILD !== 'website-server') {
        window.addEventListener('ar-preview:disable', () => {
            store.dispatch(setArPreviewStatus('qrcode'));
        });
    }
};